module.exports = "/images/invex.svg?1af73d75d06fced59ad05706b167bfa7";